import React from 'react';
import ReviewsTitle from 'views/common/components/UI/ReviewsTitle/ReviewsTitle';
import ReviewCard from 'views/common/components/UI/ReviewCard/ReviewCard';
import { useTranslation } from 'next-i18next';
import { Box, Button } from '@mui/material';
import dayjs from 'dayjs';
import StyledBox from 'views/VehicleModelView/components/ReviewSection/ReviewSection.styles';

const ReviewSection = (props) => {
  const {
    totalCount,
    reviews,
    hasReview,
    reviewFormData,
    ratingLabelTitle,
    onDataChange,
    submitReviewBtn,
    reviewError,
    addReviewState,
    currentUserReview,
    editReviewState,
    onSubmitVote,
    handleAllReviewsBtnClick,
  } = props;
  const { t } = useTranslation('fe_er_vehicle_model_page');

  return (
    <StyledBox pb={9}>
      <ReviewsTitle
        title={t('fe_er_vehicle_model_page:reviews')}
        reviewsCount={totalCount}
        reviewOverlayData={
          !hasReview && {
            data: reviewFormData,
            ratingLable: ratingLabelTitle,
            onDataChange,
            submitReviewBtn,
            reviewError,
            state: addReviewState,
            rateValue: [
              reviewFormData?.star_rating,
              reviewFormData?.star_rating_2,
              reviewFormData?.star_rating_3,
            ],
          }
        }
      />

      <Box>
        {currentUserReview && (
          <ReviewCard
            key={currentUserReview.id}
            reviewId={currentUserReview.id}
            userImage={currentUserReview.reviewer.avatar.small_url}
            userName={currentUserReview.reviewer.name}
            reviewDate={dayjs(currentUserReview.created_at).format(
              'MMMM D, YYYY HH:mm a',
            )}
            rateValue={[
              currentUserReview.star_rating,
              currentUserReview.star_rating_2,
              currentUserReview.star_rating_3,
            ]}
            ratingComponentProps={{ readOnly: true }}
            reviewDetails={[
              {
                title: currentUserReview.title,
                description: currentUserReview.body,
              },
            ]}
            editReviewDetails={{
              data: reviewFormData,
              onDataChange,
              reviewError,
              ratingLable: ratingLabelTitle,
              submitReviewBtn,
              state: editReviewState,
              rateValue: [
                reviewFormData?.star_rating || currentUserReview.star_rating,
                reviewFormData?.star_rating_2 || currentUserReview.star_rating,
                reviewFormData?.star_rating_3 || currentUserReview.star_rating,
              ],
            }}
            reviewVotes={{
              count: currentUserReview.votes,
              currentUserVote: currentUserReview.current_user_vote,
            }}
            onSubmitVote={onSubmitVote}
          />
        )}
        {reviews?.map((review) => (
          <ReviewCard
            key={review.id}
            reviewId={review.id}
            userImage={review.reviewer.avatar.small_url}
            userName={review.reviewer.name}
            reviewDate={dayjs(review.created_at).format('MMMM D, YYYY HH:mm a')}
            rateValue={[
              review.star_rating,
              review.star_rating_2,
              review.star_rating_3,
            ]}
            ratingComponentProps={{ readOnly: true }}
            reviewDetails={[
              {
                title: review.title,
                description: review.body,
              },
            ]}
            reviewVotes={{
              count: review.votes,
              currentUserVote: review.current_user_vote,
            }}
            onSubmitVote={onSubmitVote}
          />
        ))}
      </Box>
      {totalCount >= 3 && handleAllReviewsBtnClick && (
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="outlined"
            color="secondary"
            className="RSViewAllBtn"
            onClick={handleAllReviewsBtnClick}>
            {`${t('fe_er_vehicle_model_page:view_all_reviews', {
              count: totalCount,
            })}`}
          </Button>
        </Box>
      )}
    </StyledBox>
  );
};
export { ReviewSection };
